import networkAdapter from '../adapters/network';

export const fetchOwnedOperation = ( {userId} ) => {
  let legacyOptions = {
    url: `/api/eva/api/v5/operations/owned?userId=${userId}`,
    userId,
    isPagedData: true
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchAllOperations = ({ userId }) => {
  const graphRequest = {
    userId,
    query: `
      query {
        operations {
          id
          name
          owner {
            id
          }
          fields {
            id
            name
          }
        }
      }
    `
  };

  return networkAdapter({
    options: graphRequest,
    useOL: true,
    transformResponse: (data) => {
      const transformation = ({ data }) => data.operations.map(operation => ({
        operationId: operation.id,
        operationName: operation.name,
        operationOwnerId: operation.owner.id,
        permission: 'OWNER',
        fields: operation.fields
      }));
      return transformation(data); 
    }
  });
};

export const fetchSharedOperations = ( {userId} ) => {
  const legacyOptions = {
    url: `/api/eva/api/v5/operations/accessible`,
    userId,
    isPagedData: true
  };

  return networkAdapter({
    legacyOptions
  });
};
